import makeStyles from '@mui/styles/makeStyles'
import { FC } from 'react'
import { useRouter } from 'next/router'
import { usePosts } from '../../hooks/useAdmin'

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100vh',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    WebkitBackgroundSize: 'cover',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundImage: ({ image }: any) => `url(${image})`,
    [theme.breakpoints.down('sm')]: {
      height: 400,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'unset',
    },
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100%',
    backgroundColor: 'rgba(45, 45, 45, 0.5)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  messageContainer: {
    width: '100%',
    padding: '0 20px',
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textShadow: '1px 2px 2px rgba(0, 0, 0, 0.6)',

    [theme.breakpoints.down('sm')]: {
      top: '25%',
    },

    '& h1, & h2': {
      color: '#fff',
      fontWeight: 500,
    },

    '& h1': {
      fontSize: 60,
      margin: '0 0 8px',
      lineHeight: '1.2',
    },

    '& h2': {
      margin: '0',
      fontSize: 30,
    },

  },
}))

interface Props {
  title?: string;
  subtitle?: string;
}

const imageDefault = '/images/blog-banner.jpg'

export const BlogBanner:FC<Props> = ({ title, subtitle }) => {
  const { data: posts } = usePosts({})
  const router = useRouter()
  const { query } = router

  const post = posts?.results.find((post) => post.slug === query.post)
  const classes = useStyles({ image: post?.coverPage ?? imageDefault })

  return (
    <section className={classes.container} id="inicio">
      <div className={classes.overlay} />
      <div className={classes.messageContainer}>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
      </div>
    </section>
  )
}
